<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">
          Security Master
        </router-link>
        > Edit Instrument
      </section>
    </article>
    <h4>Edit Instrument (Equity)</h4>
    <article class="row">
      <section class="input-field col s2">
        <input type="number"
               placeholder="123456"
               class="validate"
               v-model="instrument.id"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">Instrument ID</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="12345"
               class="validate"
               v-model="instrument.capiq_trading_item_id"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">CapIQ Identifier</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="12345"
               class="validate"
               v-model="instrument.cusip"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">Cusip</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="12345"
               class="validate"
               v-model="instrument.isin"
               pattern="^[A-Z0-9]{3}[0-9]+$"
               disabled
        >
        <label class="active">Isin</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="FB"
               class="validate"
               v-model="payload.symbol"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">Symbol</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="FB"
               class="validate"
               v-model="payload.quotes_symbol"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">Quotes Symbol</label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.exchange_id"
                v-if="exchanges.length"
                :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
          <option v-for="exchange of exchanges" :key="exchange.id" :value="exchange.id">
            {{ exchange.symbol }}{{ exchange.quotes_symbol ? ` (${exchange.quotes_symbol})`: '' }} | {{ exchange.name }}
          </option>
        </select>
        <label class="active">Exchange</label>
      </section>
      <look-ahead id="edit-instrument-lookahead"
                  name="Company"
                  size="s4"
                  :picks="companyPicks"
                  watermark="MSFT or Microsoft"
                  :limit="100"
                  @searched="searchCompanies"
                  @picked="payload.company_id = Number($event.slice(1, $event.indexOf(' ')))"
                  :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
      />
      <section class="input-field col s4">
        <input type="text"
               placeholder="Facebook"
               class="validate"
               v-model="payload.name"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">Instrument Name</label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s2">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="payload.is_primary"
                   :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
            >
            <span>Is Primary</span>
          </label>
        </p>
      </section>
      <section class="input-field col s2">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="payload.iq_include"
                   :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
            >
            <span>IQ Include</span>
          </label>
        </p>
      </section>
      <section class="input-field col s3">
        <input id="ticker-admin-edit-instrument-inactive-date"
               type="text"
               class="datepicker"
               v-model="payload.inactive_date"
               @change="payload.inactive_date = $event.target.value"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">Inactive Date</label>
      </section>
      <section class="input-field col s2">
        <input type="number"
               placeholder=""
               class="validate"
               pattern="^[0-9]*$"
               v-model="payload.apx_security_id"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          APX Security ID
        </label>
      </section>
      <section class="input-field col s2">
        <input
          type="text"
          placeholder=""
          class="validate"
          v-model="payload.apx_symbol"
          :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        />
        <label class="active">APX Symbol</label>
      </section>
      <section class="input-field col s3">
        <input type="text"
               placeholder=""
               class="validate"
               v-model="payload.bloomberg_ticker"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          Bloomberg Ticker
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s3">
        <input type="text"
              readonly
              :value="instrument.display_name"
        >
        <label class="active blue-text">
          Computed Display Name
        </label>
      </section>
      <section class="input-field col s3">
        <input type="text"
               placeholder=""
               v-model="payload.display_name_override"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin', 'contractor-usm-admin')}">
          Display Name Override
        </label>
      </section>
      <section class="input-field col s3">
        <select class="browser-default"
                v-model="payload.security_class_id"
                v-if="securityClasses.length"
        >
          <option v-for="securityClass of acceptableSecurityClasses" :key="securityClass.id" :value="securityClass.id">
            {{ securityClass.name }}
          </option>
        </select>
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin', 'contractor-usm-admin')}">
          Security Class
        </label>
      </section>
      <section class="input-field col s3">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="payload.synced_with_xpressfeed"
                   :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
            >
            <span>Synced with Xpresfeed</span>
          </label>
        </p>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s8">
        <textarea class="materialize-textarea"
                  placeholder=""
                  v-model="payload.description"
        />
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin', 'contractor-usm-admin')}">
          Description
        </label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder=""
               class="validate"
               v-model="instrument.sedol"
               disabled
        >
        <label class="active">Sedol</label>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder=""
               class="validate"
               v-model="payload.plaid_id"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          Plaid ID
        </label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveInstrument"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import LookAhead from '@/components/LookAhead.vue';

const defaultPayload = {
  analyst_id: 0,
  instrument_id: 0,
  company_id: 0,
  exchange_id: 0,
  symbol: '',
  quotes_symbol: '',
  is_primary: false,
  apx_security_id: 0,
  apx_symbol: '',
  bloomberg_ticker: '',
  name: '',
  active: false,
  inactive_date: '',
  iq_include: false,
  synced_with_xpressfeed: true,
  display_name_override: '',
  description: '',
  security_class_id: null,
  sedol: '',
  plaid_id: '',
  capiq_trading_item_id: null,
};

export default {
  name: 'TickerAdminEditInstrument',
  components: { LookAhead },
  props: {},
  data() {
    return {
      exchanges: [],
      companies: [],
      securityClasses: [],
      instrument: { company: {}, exchange: {} },
      payload: { ...defaultPayload },
    };
  },
  computed: {
    acceptableSecurityClasses() {
      return this.securityClasses.filter(obj => obj.name === 'stock' || obj.name === 'etf');
    },
    capiq_identifier() {
      return this.$route.query.capiq_identifier || 0;
    },
    instrumentId() {
      return Number(this.$route.query.instrument_id) || 0;
    },
    companyPicks() {
      return this.companies.map(company => `#${company.id} ${company.name} ${company.capiq_identifier}`);
    },
    body() {
      const body = {
        instrument_id: this.instrument.id,
        analyst_id: this.$auth.user.pk,
        capiq_trading_item_id: this.instrument.capiq_trading_item_id,
      };
      if (this.payload.company_id !== this.instrument.company.id) { body.company_id = this.payload.company_id; }
      if (this.payload.exchange_id !== this.instrument.exchange.id) { body.exchange_id = this.payload.exchange_id; }
      if (this.payload.synced_with_xpressfeed !== this.instrument.synced_with_xpressfeed) { body.synced_with_xpressfeed = this.payload.synced_with_xpressfeed; }
      if (this.payload.symbol !== this.instrument.symbol) { body.symbol = this.payload.symbol.trim(); }
      if (this.payload.quotes_symbol !== this.instrument.quotes_symbol) { body.quotes_symbol = this.payload.quotes_symbol.trim(); }
      if (this.payload.name !== this.instrument.name) { body.name = this.payload.name.trim(); }
      if (this.payload.is_primary !== this.instrument.is_primary) { body.is_primary = this.payload.is_primary; }
      if (this.payload.iq_include !== this.instrument.iq_include) { body.iq_include = this.payload.iq_include; }
      if (this.payload.inactive_date !== this.instrument.inactive_date) {
        body.inactive_date = this.payload.inactive_date || null;
        body.active = !body.inactive_date;
      }
      if (this.payload.apx_security_id !== this.instrument.apx_security_id) { body.apx_security_id = Number(this.payload.apx_security_id) || null; }
      if (this.payload.apx_symbol !== this.instrument.apx_symbol) { body.apx_symbol = this.payload.apx_symbol.trim(); }
      if (this.payload.bloomberg_ticker !== this.instrument.bloomberg_ticker) { body.bloomberg_ticker = this.payload.bloomberg_ticker.trim(); }
      if (this.payload.display_name_override !== this.instrument.display_name_override) { body.display_name_override = this.payload.display_name_override.trim(); }
      if (this.payload.description !== this.instrument.description) { body.description = this.payload.description.trim(); }
      if (this.payload.security_class_id !== this.instrument.security_class.id) { body.security_class_id = this.payload.security_class_id; }
      if (this.payload.plaid_id !== this.instrument.plaid_id) { body.plaid_id = this.payload.plaid_id.trim(); }
      return body;
    },
  },
  watch: {},
  methods: {
    initSelect() {
      this.materialize.FormSelect.init(document.querySelectorAll('select'), {});
    },
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/exchanges/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/security_classes/`),
      ];
      const [exchangesResp, securityClassesResp] = await Promise.all(promises);
      [this.exchanges, this.securityClasses] = [exchangesResp.data, securityClassesResp.data];
    },
    async searchCompanies(query) {
      if (query) {
        const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/search/?q=${query}`);
        this.companies = data;
      }
    },
    async fetchInstrument() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/equity/?instrument_id=${this.instrumentId}`);
      this.instrument = data[0];
      this.payload.company_id = this.instrument.company.id;
      this.payload.exchange_id = this.instrument.exchange.id;
      this.payload.synced_with_xpressfeed = this.instrument.synced_with_xpressfeed;
      this.payload.symbol = this.instrument.symbol;
      this.payload.quotes_symbol = this.instrument.quotes_symbol;
      this.payload.name = this.instrument.name;
      this.payload.is_primary = this.instrument.is_primary;
      this.payload.iq_include = this.instrument.iq_include;
      this.payload.inactive_date = this.instrument.inactive_date;
      this.payload.apx_security_id = this.instrument.apx_security_id;
      this.payload.apx_symbol = this.instrument.apx_symbol;
      this.payload.bloomberg_ticker = this.instrument.bloomberg_ticker;
      this.payload.active = this.instrument.active;
      this.payload.display_name_override = this.instrument.display_name_override;
      this.payload.description = this.instrument.description;
      this.payload.security_class_id = this.instrument.security_class.id;
      this.payload.sedol = this.instrument.sedol;
      this.payload.plaid_id = this.instrument.plaid_id;
      this.payload.instrument_id = this.body.instrument_id;
      this.payload.capiq_trading_item_id = this.instrument.capiq_trading_item_id;

      document.getElementById('edit-instrument-lookahead').value = `#${this.instrument.company.id} ${this.instrument.company.name} (${this.instrument.company.capiq_identifier})`;
    },
    async saveInstrument() {
      if (![
        this.body.analyst_id,
        this.body.instrument_id,
        this.body.capiq_trading_item_id,
      ].every(arg => Boolean(arg))) {
        return this.toast('Please populate all required fields', 'pink');
      }
      if (this.body.active_date && new Date(this.body.active_date) > new Date()) {
        return this.toast('Cannot enter an Active Date in the future', 'pink');
      }
      if (this.body.inactive_date && new Date(this.body.inactive_date) > new Date()) {
        return this.toast('Cannot enter an Inactive Date in the future', 'pink');
      }
      if (String(Object.keys(this.body)) === String(['instrument_id', 'analyst_id', 'capiq_trading_item_id'])) {
        return this.toast('Please modify at least one field', 'pink');
      }
      // Change empty strings to null to avoid PUT errors.
      if (this.payload.inactive_date === '') {
        this.payload.inactive_date = null;
      }
      if (this.payload.apx_security_id === '') {
        this.payload.apx_security_id = null;
      }
      if (this.payload.bloomberg_ticker === '') {
        this.payload.bloomberg_ticker = null;
      }
      await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/equity/`, this.payload);

      this.toast('Instrument saved!', 'green');
      this.payload = { ...defaultPayload };
      document.getElementById('ticker-admin-edit-instrument-inactive-date').value = '';

      this.fetchInstrument();
    },
  },
  mounted() {
    this.fetchMetadata();
    this.fetchInstrument();
    this.initDatepicker();
    this.initSelect();
    this.payload.analyst_id = this.$auth.user.pk;
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';


</style>
